import { secureApi } from 'services/api';
import { UserInfoToPatch } from './types';
import { mapUserInfoToSnakeCase } from 'services/api/user-info/utils';
import { RootState } from 'services/store.types';
import { FeatureName } from 'types/entities/MobileSettings';
import { UserInfo } from 'types/entities/UserInfo';
import { mobileSettingsApi } from 'services/api/mobile-settings/queries';

export const userInfoApi = secureApi.injectEndpoints({
  endpoints: builder => ({
    getUserInfoV1: builder.query<UserInfo, void>({
      query: () => ({
        url: `/oauth/user`,
        method: 'GET',
      }),
      providesTags: ['User Info'],
    }),
    getUserInfoV2: builder.query<UserInfo, void>({
      query: () => ({
        url: `/oauthv2/user`,
        method: 'GET',
      }),
      providesTags: ['User Info'],
    }),
    updateUserInfo: builder.mutation<UserInfo, UserInfoToPatch>({
      query: patch => ({
        url: `/oauthv2/user`,
        method: 'PATCH',
        data: patch,
      }),
      async onQueryStarted(patch, { dispatch, queryFulfilled, getState }) {
        const state = getState() as RootState;

        const mobileSettingsResult =
          mobileSettingsApi.endpoints.getMobileSettings.select()(state);

        let isSSOEnabled = false;
        if (mobileSettingsResult.data) {
          isSSOEnabled =
            !mobileSettingsResult.data.disabledFeatureFlags.includes(
              FeatureName.SINGLE_SIGN_ON,
            );
        }

        const endpointToPatch = isSSOEnabled
          ? 'getUserInfoV2'
          : 'getUserInfoV1';

        const snakeCasePatch = mapUserInfoToSnakeCase(patch);

        const patchResult = dispatch(
          userInfoApi.util.updateQueryData(
            endpointToPatch,
            undefined,
            draft => {
              Object.assign(draft, snakeCasePatch);
            },
          ),
        );

        try {
          await queryFulfilled;
        } catch {
          patchResult.undo();
        }
      },
    }),
    deleteAccount: builder.mutation<void, void>({
      query: () => ({
        url: '/oauthv2/user',
        method: 'DELETE',
      }),
    }),
  }),
  overrideExisting: true,
});
